import React, { useState, useRef, useEffect } from "react";
import icons from "../../../assets/images/constantIcons";
import Pagination from "../../Common/Pagination";
import Table from "../../Common/Table";
import useAddStaff from "./useAddStaff";
import AddStaffForm from "./AddStaffForm";
import images from "../../../assets/images/constantImages";

const AddStaff = () => {
  const {
    columns,
    currentRows,
    totalRows,
    currentPage,
    rowsPerPage,
    handlePageChange,
    handleRowsPerPageChange,
    fetchStaffData,
    filterType,
    setFilterType,
    searchQuery,
    setSearchQuery,
    loading
  } = useAddStaff();

  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const menuRef = useRef(null);

  const openPopup = () => {
    setIsPopupOpen(!isPopupOpen);
  };

  const openDropdown = () => setDropdownOpen(!dropdownOpen);

  // handle filtering tables by active/deactive
  const handleFilterChange = (type) => {
    setFilterType(type);
    setDropdownOpen(false);
  };

  // Close the filter when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <>
      <div className="flex flex-col p-4">
        <h1 className="main_heading text-2xl xl:text-[30px] mb-3">Staff</h1>

        <div className="flex items-center justify-between gap-4">
          <button
            className="bg-buttoncolor text-white font-medium text-sm xl:text-base py-2 px-4 rounded-lg w-[120px] text-center"
            onClick={openPopup}
          >
            Add Staff
          </button>
          <AddStaffForm
            isOpen={isPopupOpen}
            onClose={openPopup}
            fetchStaffData={fetchStaffData}
          />

          <div className="flex items-center gap-3">
            <div className="flex items-center border border-gray-300 bg-white px-3 py-2 rounded-lg w-full max-w-[250px]">
              <icons.GoSearch className="text-gray-500 mr-2" />
              <input
                name="search"
                type="text"
                placeholder="Search id, email, mobile"
                className="w-full outline-none bg-transparent text-gray-700 placeholder-gray-400 placeholder:text-xs"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </div>

            {/* Filter Button */}
            <div className="relative" ref={menuRef}>
              <button
                onClick={openDropdown}
                className="bg-green700 w-10 h-10 flex items-center justify-center rounded-lg"
              >
                <img
                  src={images.dashboardsetttingicon}
                  alt="Filter"
                  className="w-5 h-5"
                />
              </button>

              {/* Dropdown Menu */}
              {dropdownOpen && (
                <div className="absolute top-12 right-0 bg-white shadow-md w-[200px] px-4 py-2 z-40 text-G500 rounded-2xl">
                  <div className="flex justify-between items-center border-b border-G20 py-1 mb-2">
                    <p className="text-base font-medium px-4">Filter</p>
                    <div
                      className="bg-green50 rounded-full p-2 cursor-pointer w-8 h-8 flex items-center justify-center"
                      onClick={openDropdown}
                    >
                      <icons.IoClose className="text-green700" />
                    </div>
                  </div>
                  <p
                    className={`text-sm text-G500 hover:bg-green50 py-2 px-4 rounded-md cursor-pointer ${filterType === "active" ? "font-semibold text-green" : ""
                      }`}
                    onClick={() => handleFilterChange("active")}
                  >
                    Active
                  </p>
                  <p
                    className={`text-sm text-G500 hover:bg-green50 py-2 px-4 rounded-md cursor-pointer ${filterType === "deactive" ? "font-semibold text-green" : ""
                      }`}
                    onClick={() => handleFilterChange("deactive")}
                  >
                    Deactive
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
        {loading ? (
          <div className="flex justify-center items-center my-4">
            <p className="text-green700 font-medium">Loading data...</p>
          </div>
        ) : (
          <div className="my-2 mb-6 overflow-auto horizontalscroll">
            <Table columns={columns} data={currentRows} />
          </div>
        )}
        {/* Pagination */}
        <Pagination
          currentPage={currentPage}
          rowsPerPage={rowsPerPage}
          totalRows={totalRows}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleRowsPerPageChange}
        />
      </div>
    </>
  );
};

export default AddStaff;
